'use client'
import { useEffect, useRef } from 'react'

declare global {
	interface Window {
		__LMC_CAREER_WIDGET__: {
			apiKey: string
			widgetId: string
			selector: string
			themes: string[]
		}
	}
}

export const TeamioLoader = ({ apiKey, widgetId }: { apiKey: string; widgetId: string }) => {
	const scriptAppended = useRef(false)

	// biome-ignore lint: <explanation>
	useEffect(() => {
		if (!scriptAppended.current) {
			window.__LMC_CAREER_WIDGET__ = {
				apiKey,
				widgetId,
				selector: '#teamioWidget',
				themes: ['base'],
			}

			const script = document.createElement('script')
			script.src = 'https://snippet.capybara.lmc.cz/js/widget-3.x.x.min.js'
			script.async = true
			script.defer = true
			document.body.appendChild(script)
			scriptAppended.current = true
			return () => {
				document.body.removeChild(script)
			}
		}
	}, [])

	return (
		<div className="teamio-widget-container">
			<div id="teamioWidget" />
			<style>{`
				#teamio {
					width: 100%;
					height: auto;
					min-height: 500px;
				}

				.cp-jobs__list {
					list-style: none;
					padding: 0;
					margin: 0;
				}

				.cp-job {
					margin-bottom: 16px;
					border-radius: 8px;
					overflow: hidden;
					box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
					transition: transform 0.2s ease-in-out;
				}

				.cp-job:hover {
					transform: translateY(-2px);
					box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
				}

				.cp-job__link {
					display: block;
					padding: 16px 20px;
					text-decoration: none;
					color: #333;
					background-color: #fff;
				}

				.cp-job__name {
					font-size: 18px;
					font-weight: 600;
					text-decoration: none;
				}

				.cp-detail {
					max-width: 800px;
					margin: 0 auto;
				}

				.cp-detail__header {
					margin-bottom: 24px;
				}

				.cp-detail__header-info p {
					margin-bottom: 16px;
				}

				.cp-detail__header-title h1 {
					font-size: 24px;
					font-weight: 700;
					margin-bottom: 20px;
				}

				.cp-detail__content p {
					margin-bottom: 16px;
				}

				.cp-detail__content ul {
					padding-left: 20px;
					margin-bottom: 20px;
				}

				.cp-detail__content li {
					margin-bottom: 8px;
				}

				.cp-detail__footer {
					margin-top: 32px;
				}

				.cp-detail__contact h2 {
					font-size: 20px;
					margin-bottom: 12px;
				}

				.cp-address__item {
					margin-bottom: 8px;
				}

				.cp-button__wrapper {
					margin-top: 24px;
					display: flex;
					gap: 16px;
					align-items: center;
				}

				.cp-button.cp-button--offset {
					margin-top: 0;
				}

				.cp-button {
					padding: 10px 20px;
					border-radius: 4px;
					cursor: pointer;
					text-decoration: none;
					display: inline-block;
				}

				.cp-button--submit {
					background-color: rgb(75 134 92);
					color: white;
					border: none;
				}

				.cp-button--submit:hover {
					background-color: rgb(55 104 68);
				}

				.cp-button--back {
					background-color: #f5f5f5;
					color: #333;
				}

				.cp-brand {
					margin-top: 24px;
					text-align: right;
				}

				.cp-brand__link {
					display: inline-block;
				}

				.cp-detail ul {
					list-style-type: disc;
					padding-left: 20px;
				}

				.cp-detail ul li {
					margin-bottom: 8px;
				}

				.cp-detail a {
					text-decoration: underline;
				}

				.cp-detail a:hover {
					text-decoration: none;
				}
			`}</style>
		</div>
	)
}
